<template>
  <NuxtLink :to="targetRoute" class="back-link" :title="t('common.back')">
    <span>
      <i
        class="fa-solid"
        :class="{
          'fa-arrow-left': !isWhitelabel,
          'fa-chevron-left': isWhitelabel,
        }"></i>
    </span>
    {{ t('common.back') }}
  </NuxtLink>
</template>

<script lang="ts" setup>
import { Routes } from '~/enums/Routes'
import { useLang } from '~/composables/useLang'
import getLocalizedRoute from '~/utils/getLocalizedRoute'

const { t } = useLang()
const { isWhitelabel } = useTheme()

const targetRoute = getLocalizedRoute(Routes.Account.SitePro)
</script>

<style lang="postcss" scoped>
.back-link {
  @apply flex items-center justify-center font-bold h-[3.125rem] text-black dark:text-white gap-4 text-sm xl:px-[2rem] hover:no-underline
  focus:no-underline;
  span {
    @apply text-neutral3 dark:text-dmText3 text-xl flex;
  }
}
</style>

<style lang="postcss" scoped>
.wl {
  .back-link {
    @apply text-brand-primary font-bold;

    span {
      @apply text-brand-primary text-sm font-bold;
    }
  }
}
</style>
